/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {ModelState}
 */
export const modelState = {
    current: {},
    loading: false,
};


/**
 * @typedef {object} Model
 * @property {string} type
 * @property {BannerImage=} banner_image - Optional banner image
 */

/**
 * @typedef {object} ModelState
 * @property {Model} current
 * @property {boolean} loading
 */

/**
 * @typedef {object} BannerImage
 * @property {string} image - Image identifier as a guid
 * @property {BannerImageSettings} settings
 */

/**
 * @typedef {object} BannerImageSettings
 * @property {string} format
 * @property {BannerImageSettingsOptions} options
 */

/**
 * @typedef {object} BannerImageSettingsOptions
 * @property {number} dimension
 * @property {string} method
 * @property {string} position
 * @property {boolean} useCaption
*/
